import { useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import AutoCompleteField from "./autocomplete";

const months = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" },
];

const monthsEmpty = [{ value: "", label: "Mês" }, ...months];

function getYears({ yearsCount, direction = "past" }) {
  const currentYear = new Date().getFullYear();
  const years = [];

  if (direction === "both") {
    // Anos passados (do mais antigo ao atual)
    for (let i = yearsCount; i >= 1; i--) {
      const year = currentYear - i;
      years.push({ value: year, label: String(year) });
    }
    // Ano atual
    years.push({ value: currentYear, label: String(currentYear) });
    // Anos futuros
    for (let i = 1; i <= yearsCount; i++) {
      const year = currentYear + i;
      years.push({ value: year, label: String(year) });
    }
  } else if (direction === "future") {
    for (let i = 0; i <= yearsCount; i++) {
      const year = currentYear + i;
      years.push({ value: year, label: String(year) });
    }
  } else {
    // "past" (default)
    for (let i = 0; i <= yearsCount; i++) {
      const year = currentYear - i;
      years.push({ value: year, label: String(year) });
    }
  }

  return years;
}

function MonthDropdown({
  month,
  handleMonthChange,
  disabled,
  displayEmpty,
  required,
}) {
  return (
    <AutoCompleteField
      label="Período"
      options={displayEmpty ? monthsEmpty : months}
      value={month || months[0]}
      onChange={handleMonthChange}
      disabled={disabled}
      optionLabelKey="label"
      optionIdKey="value"
    />
  );
}

function YearDropdown({
  year,
  handleYearChange,
  disabled,
  displayEmpty,
  yearsCount,
  direction,
}) {
  const years = useMemo(
    () => getYears({ yearsCount, direction }),
    [yearsCount, direction]
  );
  const yearsEmpty = [{ value: "", label: "Ano" }, ...years];

  return (
    <AutoCompleteField
      options={displayEmpty ? yearsEmpty : years}
      value={year || years[0]}
      onChange={handleYearChange}
      disabled={disabled}
      optionLabelKey="label"
      optionIdKey="value"
    />
  );
}

export default function MonthYearField({
  month,
  handleMonthChange,
  year,
  handleYearChange,
  disabled,
  displayEmpty,
  required,
  lg = 3,
  md = 6,
  yearsCount = 5,
  direction = "past", // "past" | "future" | "both"
}) {
  return (
    <Grid item xs={12} md={md} lg={lg}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={6}>
          <MonthDropdown
            month={month}
            handleMonthChange={handleMonthChange}
            disabled={disabled}
            displayEmpty={displayEmpty}
            required={required}
          />
        </Grid>
        <Grid item xs={6}>
          <YearDropdown
            year={year}
            handleYearChange={handleYearChange}
            disabled={disabled}
            displayEmpty={displayEmpty}
            yearsCount={yearsCount}
            direction={direction}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
